import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Ticket() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        {/*
        <div className="p-3">
          <Typography className="text-danger font-weight-bold line180 my-2" variant="h6" component="h2">
            ■JAZZ LIVE in デーリー東北 開催延期のお知らせ
          </Typography>
          <Typography className="text-danger font-weight-bold line180 my-2" variant="body1" component="h2">
            ▼チケット払い戻しいたします（5月14日（金）まで）
          </Typography>
          <Typography className="text-danger line180 my-2" variant="body1" component="h2">
            　5月1日にデーリー東北ホールで開催予定の JAZZ LIVE in デーリー東北は延期します。<br />
            　新型コロナウイルスの感染拡大により、青森県教委が5月5日まで県立学校の部活動の対外試合などを禁止する通知を出しました。出演する八戸ジャズ楽団のメンバーには中高生がいるため、今回の対応を決めました。<br  />
            　チケットをご購入された方は、お手数ですがデーリー東北新聞社読者コミュニケーション部までご連絡ください。チケットと引き替えに払い戻しいたします。（5月14日（金）まで）<br />
            　延期後の開催期日が決まりましたら、紙面広告にてお知らせいたします。
          </Typography>
          <Typography className="text-danger line180 my-4" variant="body1" component="h2">
            <dl>
              <dt>問い合わせ</dt>
              <dd>
                デーリー東北新聞社 3階読者局 読者コミュニケーション部<br />
                TEL：0178-44-5111（平日午前10時~午後5時）
              </dd>
            </dl>
          </Typography>
        </div>
        */}

        <div className="p-3">
          <Typography className="text-danger font-weight-bold line180 my-2" variant="h6" component="h2">
            ■デーリー東北チケットセンター　本社３階読者局に移動
          </Typography>
          <Typography className="text-danger line180 my-2" variant="body1" component="h2">
          　デーリー東北新聞社は４月１日より、これまで本社１階で対応していたデーリー東北チケットセンターを、３階の読者局読者コミュニケーション部に移動します。営業時間は午前１０時～午後４時。土日・祝日、お盆、年末年始は休み。問い合わせはデーリー東北チケットセンター＝電話0178（73）2882＝へ。
          </Typography>
        </div>

{/*
        <Paper className="p-3 my-3">
          <Typography className="text-danger font-weight-bold line180" variant="h6" component="h2">
            12月27日～来年1月3日まで休業となります。<br />
            業務開始は4日午前10時からとなります。<br />
          </Typography>
        </Paper>
*/}

{/*
        <Box my={8}>
          <Paper className="p-3 my-3">
            <Typography className="text-danger font-weight-bold line180" variant="h6" component="h2">
              当社チケットセンターでは以下の期間をお盆休みとさせていただきます。<br />
              ご迷惑をおかけしますが、ご了承のほどよろしくお願いします。<br />
              お盆休み期間：8月13日（木）〜16日（日）<br />
            </Typography>
            <section className="mb-5">
              新型コロナウィルス感染症対策のため、以下のイベントは中止となりました。
              <div className="my-3">
                <div className="font-weight-bold">＜中止①＞</div>
                イベント：「鍵盤男子」チャリティーコンサート<br />
                会場：八戸プラザアーバンホール<br />
                ▽６月７日（日）１４時半<br />
                ▽前売券 8,500円<br />
                ▽払戻お問い合わせは、直接、国際ソロプチミスト八戸事務局まで ℡0178-46-2540（月・木のみ）<br />
              </div>
              <div className="my-3">
                <div className="font-weight-bold">＜中止②＞</div>
                イベント：サエラスペシャルコンサート ～ Memory・母の記憶 ～ ピアノと歌と朗読が織りなす、追憶の刻…。<br />
                会場：八戸市公民館<br />
                【出演者】高橋朋子（ピアノ）、市毛良枝（語り）、菊地由利子（ヴォーカル）<br />
                ▽６月７日（日）１４時半<br />
                ▽全席自由 ３５００円<br />
                ▽払戻はデーリー東北での購入分は、当センターにて返金します。その他店舗での購入分は、6月7日（日）14～16時、八戸市公民館で返金します。<br />
                ▽お問い合わせは、サエラ事務所 ℡0173-26-7755<br />
              </div>
            </section>
*/}

            {/*
            <Typography className="font-weight-bold my-3" variant="h6" component="h2" className="text-danger font-weight-bold">
              新型コロナウイルスの感染拡大を受け、現在、チケットのお取り扱いはございません。
            </Typography>
            */}

            <Typography className="font-weight-bold my-5" variant="h5" component="h2">
              チケット情報（１０月２９日現在）
            </Typography>

            {/*
            <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
              FLAT HACHINOHE
            </Typography>
            <dl>
              <dt>青森ワッツ　第2節ホーム開幕戦　VS西宮ストークス</dt>
              <dd>
                10月9日(土)　 18：00開始　FLAT HACHINOHE<br/>
                10月10日(日)　14：00開始　FLAT HACHINOHE<br/>
                ▽1F　自由席　大人3,000円　小中高2,000円<br />
                ▽2F　自由席　大人2,000円　小中高1,000円<br />
                ※ホーム開幕節(10/9・10)FLAT　HACHINOHE開催の価格となりますのでご注意ください。<br />
              </dd>
            </dl>

            <div class="text-danger line150 text-left m-3">
              ※その他の席のお取り扱いにつきましては、「<a href="https://aomori-wats.jp/ticket/" target="_blank">青森ワッツ公式HP</a>」内の案内をご覧ください。<br/>
            </div>
            */}

            {/*
            <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
              八戸市東運動公園・東体育館
            </Typography>
            <dl>
              <dt>2020－21　Ｂ２リーグ戦　青森ワッツ vs FE名古屋</dt>
              <dd>
                ▽２月６日（土）１８時<br/>
                ▽２月７日（日）１４時<br/>
                ▽自由席２階大人１５００円、小中高５００円（当日各５００円増し）<br/>
                ▽チケット販売は1月２２日（金）～２月６日（土）までとなります。<br/>
              </dd>
            </dl>

            <div class="text-danger line150 text-left m-3">
              ※その他の席のお取り扱いにつきましては、「<a href="https://aomori-wats.jp/ticket/" target="_blank">青森ワッツ公式HP</a>」内の案内をご覧ください。<br/>
            </div>
            */}

            {/*
            <Box my={4}>
              <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                階上町　寺下観音　茶屋　東門
              </Typography>
              <dl>
                <dt>寺久保エレナ・カルテット</dt>
                <dd>
                  【出演者】寺久保エレナ（アルト・サックス）、片倉真由子（ピアノ）、金森もとい（ベース）、高橋信之介（ドラムス）
                </dd>
                <dd>
                  ▽9月15日（火）19時半<br />
                  ▽全席自由一般5000円、小中高大生2500円（当日各500円増し）、未就学児不可<br />
                  ▽要1ドリンクオーダー<br />
                </dd>
              </dl>
            </Box>
            */}

              <Typography className="font-weight-bold mt-5 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                八戸市公会堂
              </Typography>

              <Grid className="my-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <a href="/ticket/20210907-kyogen.pdf">
                    <img src="/ticket/20210907-kyogen.jpg" className="img-fluid" />
                  </a>
                </Grid>
                <Grid item xs={12} md={8}>
                  <dl>
                    <dt>野村万作・萬斎　狂言　八戸特別公演</dt>
                    <dd>
                      　デーリー東北新聞社は９月７日（火）、「野村万作・萬斎　狂言　八戸特別公演」を開催します。万作の会による八戸公演は２０１９年以来です。ユネスコ世界無形文化遺産に登録された伝統芸能をお楽しみください。<br />
                      　◇開演時間　午後６時半（同５時半開場）<br />
                      　◇開催場所　八戸市公会堂<br />
                      　◇チケット　全席指定。ＳＳ席１万円<span className="font-weight-bold text-danger">（残りわずか）</span>、Ｓ席９千円、Ａ席７千円（いずれも税込み）<br />
                      　人間国宝の野村万作さん、マルチな才能を発揮し多方面で活躍中の野村萬斎さんを迎えます。演目は「千鳥」と「舟渡聟」。ともにお酒を巡る２人の駆け引きが楽しい作品です。庶民の誰もが持っている生活感情の機微を、洗練された笑いに表現します。<br />
                      {/*
                      <Typography className="font-weight-bold my-3 rounded text-dark" variant="subtitle1" component="div">
                        来月５日チケット先行販売
                      </Typography>
                      　チケットは７月５日（月）午後１時から７時まで、デーリー東北チケットセンターにて、「デリオンくらぶ」会員限定で先行販売します。一般販売は同１２日（月）午前１０時から、同センターのほか市内プレイガイドで行います。
                      */}
                    </dd>
                  </dl>
                </Grid>
              </Grid>
              <div className="p-3">
                <Typography className="text-danger font-weight-bold line180 my-2" variant="h6" component="h2">
                  野村万作・萬斎　狂言八戸特別公演について
                </Typography>
                　新型コロナウイルスの感染拡大が続く状況の中で、来場者の皆様の安全を第一に考え、開催を延期します。※公演の振替日は未定です。<br />
                　デーリー東北チケットセンター、八戸市公会堂、三春屋、ラピアの各プレイガイドでご購入いただきましたチケットは全額払い戻しさせていただきますのでご持参ください。購入した同公演のチケットが対象となり、各プレイガイドで購入した分についてもデーリー東北新聞社にて払い戻しとなります。<br />
                <br />
                ▽払い戻し開始日：９月１日（水）<br />
                ▽払い戻し期限：10月29日(金)<br />
                ▽時間　午前１０時～午後５時<br />
                ▽場所　デーリー東北新聞社１階<br />
                ※９月４日（土）、５日（日）も返金対応致します。（以後は平日のみ）<br />
                <br />
                〇期限を過ぎてしまいますと対応いたしかねますのでご注意ください。<br />
                〇払い戻し対象は、チケット代金のみとなります。<br />
                〇払い戻し済みのチケットは回収させていただきます。<br />
              </div>
              <Divider />
              {/*
              <Grid className="my-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <a href="/ticket/20210926-sendai-phil.pdf">
                    <img src="/ticket/20210926-sendai-phil.jpg" className="img-fluid" />
                  </a>
                </Grid>
                <Grid item xs={12} md={8}>
                  <dl>
                    <dt>仙台フィルハーモニー管弦楽団　ガラ・コンサート</dt>
                    <dd>
                      【出演者】松井慶太（指揮）、森麻季（ソプラノ）、錦織健（テノール）、仲道祐子（ピアノ）
                    </dd>
                    <dd>
                      　◇開演　16：00（開場　15：00）<br />
                      　◇チケット　全席指定。一般7,000円　高校生以下、障がい者割引3,500円（いずれも税込み）<br />
                    </dd>
                  </dl>
                </Grid>
              </Grid>
              <Divider />
              */}
              {/*
              <Grid className="my-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <a href="/ticket/20211102-disney-on-classic.pdf">
                    <img src="/ticket/20211102-disney-on-classic.jpg" className="img-fluid" />
                  </a>
                </Grid>
                <Grid item xs={12} md={8}>
                  <dl>
                    <dt>Disney on CLASSIC まほうの夜の音楽会</dt>
                    <dd>
                      　◇開演　19：00（開場　18：00）<br />
                      　◇チケット　S：8,800円、A：7,500円（全席指定、消費税込）<br />
                    </dd>
                  </dl>
                </Grid>
              </Grid>
              */}
              {/*
              <Divider />
              <Grid className="my-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <a href="/ticket/20210629-tao.pdf">
                    <img src="/ticket/20210629-tao.jpg" className="img-fluid" />
                  </a>
                </Grid>
                <Grid item xs={12} md={8}>
                  <dl>
                    <dt>DRUMTAO～2021年新作舞台 光～</dt>
                    <dd>
                      ▽６月29日(火)午後３時、午後７時<br />
                      ▽全席指定 S席7,000円(１階席)/A席6,500円(２階席)<br />
                      ※全席指定・税込<br />
                      ※前売・当日券同額<br />
                      ※６歳未満のご入場はお断りいたします。<br />
                      ※車椅子席をお求めの方は八戸市公会堂までお問い合わせください。<br />
                      ※当日は新型コロナウイルス感染対策をしています。<br />
                    </dd>
                  </dl>
                </Grid>
              </Grid>
              */}
              {/*}
              <Typography className="font-weight-bold mt-5 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                プライフーズスタジアム（八戸市多賀多目的運動場内）
              </Typography>
              <Grid className="my-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={12}>
                  <dl>
                    <dt>県民共済Presents 〜AOMORI SUPER CUP〜</dt>
                    <dd>
                      ▽８月１４日（土）午前１１時　開門<br/>
                      ▽芝生エリア一般（自由席）１０００円、小中高８００円　税込み<br/>
                    </dd>
                  </dl>
                  <div class="text-danger line150 text-left m-3">
                    ※イベント詳細は、<a href="https://aomori-super-cup.com/" target="_blank">特設サイト</a>をご覧ください。<br/>
                  </div>
                </Grid>
              </Grid>
              */}
              
              {/*
              <Typography className="font-weight-bold mt-5 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                映画チケット
              </Typography>
              <Grid className="my-3" spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={12} className="p-3">
                  <dl>
                    <dt>映画「犬部！」</dt>
                    <dd>
                      ▽７月２２日（木）全国ロードショー<br />
                      ▽ムビチケ前売り券（カード）1,500円（税込）<br />
                    </dd>
                  </dl>
                </Grid>
              </Grid>
              */}

  {/*
              <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                デーリー東北ホール
              </Typography>
              <dl>
                <dt>JAZZ×CLASSIC</dt>
                <dd>
                  ▽４月２９日　①13:00（12:30開場）　②17:30（17:00開場）各回50席限定<br />
                  ▽全席自由 大人3,000円　中学生以下1,500円　未就学児 無料<br />
                  ▽チケット購入時に配布される「健康チェックシート」を記入し持参してください。<br />
                  ▽当日は新型コロナウィルス感染対策をしています。<br />
                </dd>
              </dl>
*/}

{/*
              <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                デーリー東北新聞社６階メディアホール
              </Typography>
              <dl>
                <dt>道Vol.４</dt>
                <dd>
                  【出演者】澤向直子（ヴィオラ）、佐藤慎悟（ピアノ）
                </dd>
                <dd>
                  ▽11月28日　昼の部13時30分、夜の部18時30分<br />
                  ▽全席自由2000円、小学生以下無料（限定60名様、当日券なし）<br />
                </dd>
                <dd>
                  ※当日はコロナウィルス感染対策をしています。会場入り口にて、お名前、ご連絡先の記入、検温、消毒、マスク着用をお願いいたします。
                </dd>
              </dl>
*/}
{/*
              <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                八戸市文化教養センター 南部会館
              </Typography>
              <dl>
                <dt>お座敷えんぶり（内丸えんぶり組…どうさいえんぶり）</dt>
                <dd>
                  ▽２月１５日（土）１３時半<br/>
                  ▽全席自由（大広間座敷）　御膳弁当・飲み物付き４４００円（いす席３０席有り）<br/>
                </dd>
              </dl>
*/}
{/*
              <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                八戸プラザアーバンホール
              </Typography>
              <dl>
                <dt>国際ソロプチミスト八戸認証45周年記念「鍵盤男子」チャリティーコンサート</dt>
                <dd>
                  【出演者】ピアノ…大井健×中村匡宏
                </dd>
                <dd>
                  ▽５月１６日（土）１３時（ランチ正午）<br/>
                  ▽全席自由　ランチ付８５００円、未就学児入場不可<br/>
                </dd>
              </dl>
*/}

{/*
              <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                テクノルアイスパーク八戸
              </Typography>
              <dl>
                <dt>アジアリーグアイスホッケー2019-2020　東北フリーブレイズ　VS　ひがし北海道クレインズ</dt>
                <dd>
                  ▽１２月２７日（金）１９時<br/>
                  ▽１２月２８日（土）１７時<br/>
                  ▽１２月２９日（日）１５時半<br/>
                  ▽自由席一般１５００円、小中高１０００円、未就学児無料<br/>
                </dd>
                <dt>アジアリーグアイスホッケー2019-2020　東北フリーブレイズ　VS　H.C.栃木日光アイスバックス</dt>
                <dd>
                  ▽２０２０年１月１７日（金）１９時<br/>
                  ▽２０２０年１月１８日（土）１７時<br/>
                  ▽２０２０年１月１９日（日）１５時半<br/>
                  ▽自由席一般１５００円、小中高１０００円、未就学児無料<br/>
                </dd>
              </dl>
              <div class="text-danger line150 text-left m-3">
                ※その他の席のお取り扱いにつきましては、「<a href="http://www.tohokufreeblades.com/" target="_blank">東北フリーブレイズ公式HP</a>」内の案内をご覧ください。<br/>
              </div>

              <Typography className="font-weight-bold my-3 text-center bg-dark rounded text-white" variant="subtitle1" component="div">
                三沢市国際交流スポーツセンター
              </Typography>
              <dl>
                <dt>Ｂ２リーグ　青森ワッツ　VS　仙台89ERS</dt>
                <dd>
                  ▽２０２０年１月１８日（土）１８時<br/>
                  ▽２０２０年１月１９日（日）１４時<br/>
                  ▽自由席１階大人２５００円、小中高１５００円、２階大人１５００円、小中高５００円（当日５００円増し）<br/>
                </dd>
              </dl>
              <div class="text-danger line150 text-left m-3">
                ※その他の席のお取り扱いにつきましては、「<a href="https://aomori-wats.jp/ticket/" target="_blank">青森ワッツ公式HP</a>」内の案内をご覧ください。<br/>
              </div>
          </Paper>
        </Box>
*/}

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            デーリー東北チケットセンターについて
          </Typography>
          <dl>
            <dt>座席が選べます</dt>
            <dd>
              デーリー東北チケットセンターは対面販売になりますので、座席を直接ご確認の上、ご購入できます。
            </dd>
            <dt>会員向け先行販売も</dt>
            <dd>
              デーリー東北主催イベントは、デリオンくらぶ会員を対象とした先行販売がございます。（入会金・年会費無料）
              <Box my={4} textAlign="center">
                <Grid className="px-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="http://feature.daily-tohoku.co.jp/dt_club/index.php" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      デリオンクラブについて
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </dd>
            <dt>販売店受取も可能</dt>
            <dd>
              お電話でご購入の方は、「デーリー東北」配達エリアの販売店で、チケットの受け取りが可能です。
            </dd>
            <dt>チケットの取り扱いを希望される方</dt>
            <dd>
              デーリー東北チケットセンターでチケットを販売してほしい方は、「チケット販売依頼書」をご提出ください。
              <Box my={4} textAlign="center">
                <Grid className="px-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={4}>
                    <CustomButton href="/pdf/ticket/request-sale.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                      チケット販売依頼書
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北チケットセンター（デーリー東北新聞社内）</dt>
            <dd>
              <PhoneEnabledIcon /> 0178-73-2882（直通）<br/>
              ※受付時間　午前10時～午後４時（平日）
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default Ticket;
